export enum EcsProjectTeamName {
  YammerClients = 'YammerClients',
  CrossPlatform = 'CrossPlatform',
  ClientForward = 'ClientForward',
}

export interface EcsConfig {
  readonly etag: string;
  readonly configIds: {
    readonly [configIdKey: string]: string;
  };
}
